import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";

import gnpVideos from "./gnp-videos.css";
import oVideosData from "./gnp-videos-datos";
import { firebaseCfg } from "./../properties";

const mapState = (state) => {
	return {};
};

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "VIDEO_SET_EVENT", "evento": evento});
		}
	};
};

class GnpVideos extends React.Component {

	state = {
		"videoVisible": undefined,
	}

	videoPop = (id) =>{
		for (var i = 0; i < oVideosData.length; i++) {
			if (oVideosData[i].id == id) {
				if (oVideosData[i].video) {
					this.setState({"videoVisible": id});
				} else {
					this.props.toggle(id);
				}
				break;
			}
		}
	}

	videoUnPop = (id) => {
		this.setState({"videoVisible": undefined});
		document.getElementById(id.toString()).pause();
	}

	detalle = (item) => {
		goTo("gnp/servicios-videos/" +  item.id);
		this.props.addEvento("MasInfo-"+item.titulo);
	}

	render() {
		let idThumb = 0;
		return (
			<div className="gnp-videos">
				{ oVideosData.map((item,i) => {
					return (
						<div className="video-contenedor" key={i}>
							<div className="video-imagen" onClick={this.videoPop.bind(this, item.id)} style={{"backgroundImage":"url("+item.imagen+")"}}></div>
							<div className="video-texto">
								<p className="titulo">{item.titulo}</p>
								<span></span>
								<p className="descripcion">{item.subtitulo}</p>
								<button onClick={this.detalle.bind(this, item)}>Más info</button>
							</div>
							{ this.state.videoVisible == item.id &&
								<div className="video-pop-up video-open">
									<div className="close-video" onClick={this.videoUnPop.bind(this, item.id)} ><img src={require("../img/close-icono.png")} /></div>
									<video className="video-selector" id={item.id} width="100%" height="100%" controls autoPlay controlsList="nodownload">
										<source src={"https://storage.googleapis.com/" + firebaseCfg.storageBucket + "/videos/" + item.video} className={item.id} type="video/mp4" />
										:( !Ups¡ Lo sentimos, tu navegador es obsoleto, por favor actualizalo.
									</video>
								</div>
							}
							<div className={this.state.videoVisible != undefined ? "background-video" : "background-video hide-anime"}></div>
						</div>
					);
				})}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(GnpVideos);



// WEBPACK FOOTER //
// ./src/gnp-servicios/gnp-videos.cmpt.js